import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { KycRequestProcess } from 'further-types/lp/kyc';
import { kycRequestProcessLabels } from 'further-ui/labels';
import useOnboardingSettings from 'hooks/lp/data/vehicle/useOnboardingSettings';

const schema = z.object({
  kycRequestProcess: z.nativeEnum(KycRequestProcess),
});

type FormValues = z.infer<typeof schema>;

const useKycSettings = (vehicleId: string) => {
  const { onboardingSettings, updateOnboardingSettings } =
    useOnboardingSettings(vehicleId);

  const { control, watch } = useForm<FormValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      kycRequestProcess: onboardingSettings.kycRequestProcess,
    },
  });

  const kycRequestProcess = watch('kycRequestProcess');

  const kycRequestProcessOptions = Object.values(KycRequestProcess).map(
    (process) => ({
      label: kycRequestProcessLabels[process],
      value: process,
    }),
  );

  const handleKycRequestProcessChange = (value: KycRequestProcess) => {
    updateOnboardingSettings({
      kycRequestProcess: value,
    });
  };

  return {
    control,
    kycRequestProcess,
    kycRequestProcessOptions,
    handleKycRequestProcessChange,
  };
};

export default useKycSettings;
